export default "__VITE_ASSET__DSQEjM_G__"